
import $ from 'jquery';
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { KanbanState } from '../kanban.model';
import Spinner from '../../util/Spinner';
import { Card, WorkflowApproval, WorkflowApprovalApproveRequest } from '../../backend/backendapi';
import { handleError } from '../../../api';

Vue.use(Toasted, { duration: 2000 });

@Component({
  name: 'ApprovalApproveModal',
  components: {
    Spinner,
  },
})
export default class ApprovalApproveModal extends Vue {
  @Prop({ required: true })
  readonly state!: KanbanState;

  request: WorkflowApproval | null = null;
  signature: string | null = null;
  saving: boolean = false;

  get canSave(): boolean {
    return !!this.signature;
  }

  get cards(): Card[] {
    if (!this.request) {
      return [];
    }
    const cardIds = new Set(this.request.cards?.map(e => e.cardId) ?? []);
    return this.state.boards
        .map(b => (b.tickets ?? [])
            .map(f => (f.cards ?? []).filter(c => cardIds.has(c.id!)))
            .reduce((a, b) => a.concat(b), []),
        )
        .reduce((a, b) => a.concat(b), []);
  }

  public open(request: WorkflowApproval): void {
    this.request = request;
    this.signature = null;
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  openCard(card: Card): void {
    const board = this.state.boards.find(b => (b.tickets ?? []).some(f => (f.cards ?? []).some(c => c.id === card.id)));
    const flow = (board?.tickets ?? []).find(f => (f.cards ?? []).some(c => c.id === card.id));
    this.$emit('openCard', { board: board, flow: flow, card: card, readonly: true });
  }

  async save(): Promise<void> {
    this.saving = true;
    try {
      const approval = WorkflowApprovalApproveRequest.fromJS({ approvalId: this.request!.id, signature: this.signature! });
      await this.state.approvalAPI.approve(approval);
      this.$toasted.info(this.$t('kanban.approval.approveModal.requestApproved').toString());

      const index = this.state.openApprovals.findIndex(e => e.id === this.request!.id);
      if (index >= 0) {
        this.state.openApprovals.splice(index, 1);
      }

      this.dismiss();
    } catch (e) {
      handleError(this.$toasted, this.$i18n, e);
    } finally {
      this.saving = false;
    }
  }
}
